import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export default function ProtectedRoute() {
  const token = localStorage.getItem('authToken');
  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userRoleName');
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}
